// Physical acceptance is maintained in docs/releases/customer-hardware-checklist-20261011.md.
// Development/test status is never customer-facing. Availability is enforced by featureAvailable.
export function FeatureSupportNote(_props:{id:string;locale:'da-DK'|'en-GB';color:string;compact?:boolean}) { return null; }
